import { spacing } from '../../theme'
import { HeadingElements } from '../Header/Header'
import { Flex } from '../layout/Flex'
import Text from '../Text/Text'

export interface HeroHeaderProps {
  title: string
  titleElement: HeadingElements
  body?: string
}

export default ({ title, titleElement, body }: HeroHeaderProps) => {
  return (
    <Flex flexDirection="column" alignItems="center" gap={spacing.m} as="header">
      <Text typography="headlineLarge" color="textStandard" as={titleElement}>
        {title}
      </Text>
      {body && (
        <Text typography="body" color="textSubtle" as="p">
          {body}
        </Text>
      )}
    </Flex>
  )
}
